/* global google */

import {
  GoogleMap,
  InfoWindow,
  Marker,
  withGoogleMap,
} from 'react-google-maps'
import React, { Component } from 'react'
import farmIcon from '../images/farmhouse.png'
import mapStyle from '../MapStyle.json'
import queryString from 'query-string'
import { withStyles } from 'material-ui/styles'

const styles = () => ({
  readMore: {
    background: 'none!important',
    color: 'inherit',
    border: 'none',
    padding: '0!important',
    font: 'inherit',
    cursor: 'pointer',
  },
})

const googleMapURL =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyC4Thxv1J1hfYU0BMdDCjFoqwxMgrsZaEU&libraries=geometry'

function createMarkerArray(filteredFarms) {
  return filteredFarms.map(farm => ({
    id: farm.FarmID,
    position: {
      lat: farm.Lat,
      lng: farm.Lng,
    },
  }))
}

function createCommodityString(commodityArray) {
  let commodityString = ''
  let i = 1
  const arrayLength = commodityArray.length
  commodityArray.forEach((commodity, index) => {
    i < arrayLength
      ? commodityString += `${commodity.Name}, `
      : commodityString += `${commodity.Name}.`
    i++
  })
  return commodityString
}

class Map extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mapRef: null,
    }
  }

  getMapRef = (element) => {
    this.setState(prevState => ({ mapRef: element }))
  }

  onMapDragEnd = () => {
    const lat = this.state.mapRef.getCenter().lat()
    const lng = this.state.mapRef.getCenter().lng()
    if(this.props.history.location.pathname === '/interactive_map') {
      this.props.updateUrlParams(
        this.props.history,
        `/interactive_map?zip=${this.props.zip}
        &distance=${this.props.distance}
        &lat=${lat}
        &lng=${lng}`.replace(/\s/g, '')
      )
    }
  }

  onMapClick = (event) => {
    if(this.props.history.location.pathname === '/interactive_map') {
      this.props.changeActiveWindow()
    }
  }

  onMarkerClick = (marker) => () => {
    if(this.props.history.location.pathname === '/interactive_map') {
      this.props.getFarmInfo(marker.id)
      this.props.changeActiveWindow(marker.id)
    }
  }

  onReadMoreClick = (farmId) => () => {
    this.props.updateUrlParams(
      this.props.history,
      `/farm_info?farm=${farmId}`
    )
  }

  onInfoWindowClose = (markerId) => () => {
    this.props.changeActiveWindow(markerId)
  }

  render() {
    const image = {
      url: farmIcon,
      scaledSize: new google.maps.Size(25, 25),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0),
    }

    const {
      classes,
      mapCenter,
      mapZoom,
      history,
      filteredFarms,
      activeWindow,
      selectedFarm,
    } = this.props

    return (
      <GoogleMap
        center={mapCenter}
        googleMapURL={googleMapURL}
        onClick={this.onMapClick}
        onDragEnd={this.onMapDragEnd}
        options={{
          styles: mapStyle.styles,
          mapTypeControl: false,
          streetViewControl: false,
          scrollWheel: true,
          navigationControl: false,
          draggable: history.location.pathname === '/interactive_map' ? true : false,
        }}
        ref={this.getMapRef}
        zoom={history.location.pathname === '/interactive_map' ? 7 : 10}
      >
        {
          createMarkerArray(filteredFarms).map((marker) => (
            <Marker
              icon={image}
              key={marker.id}
              onClick={this.onMarkerClick(marker)}
              position={marker.position}
            >
              {
                (
                  marker.id === activeWindow &&
                  selectedFarm &&
                  selectedFarm.FarmID === activeWindow
                ) &&
                (
                  <InfoWindow
                    onCloseClick={this.onInfoWindowClose(marker.id)}
                  >
                    <div style={{ display: 'flex', width: '550px', alignItems: 'center' }}>
                      <div style={{ flex: 1, marginRight: '1rem' }}>
                        <img
                          alt={`${selectedFarm.Name}`}
                          src={`https://images.producealliance.com/farm/${activeWindow}`}
                          style={{ width: '125px', height: 'auto' }}
                        />
                      </div>
                      <div style={{ flex: 2, textAlign: 'left' }}>
                        <h3>{selectedFarm.Name}</h3>
                        <p>{selectedFarm.Address}, {selectedFarm.City}, {selectedFarm.State} {selectedFarm.Zip}</p>
                        <p>Crops: {createCommodityString(selectedFarm.Commodities)}</p>
                        <p>{selectedFarm.Story}</p>
                        <p>
                          <button
                            className={classes.readMore} 
                            onClick={this.onReadMoreClick(selectedFarm.FarmID)}
                          >
                            Read More
                          </button>
                        </p>
                      </div>
                    </div>
                  </InfoWindow>
                )
              }
            </Marker>
          ))
        }
      </GoogleMap>
    )
  }
}

export default withGoogleMap(withStyles(styles)(Map))



// WEBPACK FOOTER //
// ./src/components/Map.js